import { render, staticRenderFns } from "./outrightodds.vue?vue&type=template&id=3d8003f0&scoped=true"
import script from "./outrightodds.vue?vue&type=script&lang=js"
export * from "./outrightodds.vue?vue&type=script&lang=js"
import style0 from "./outrightodds.vue?vue&type=style&index=0&id=3d8003f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8003f0",
  null
  
)

export default component.exports